import { useFormContext, useWatch } from 'react-hook-form';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { FormFields, ROTH_ACCOUNT_TYPES } from '../../AccountForm.meta';
import { AccountType } from '../../../../../../api/useAccountsOptionsQuery';

export const useEmployerMatch = () => {
  const {
    options: { EmployerMatchUnits: employerMatchUnitsOptions },
  } = useAccountFormContext();

  const { watch } = useFormContext<FormFields>();

  const [accountType, employerMatchUnits] = watch([
    'bankAccount.AccountType',
    'bankAccount.EmployerMatchUnits',
  ]);

  const {
    options: { AccountTypeOptions },
  } = useAccountFormContext();

  if (accountType === null || accountType === undefined) {
    throw new Error('Account type not found');
  }

  const accountTypeOptions = AccountTypeOptions.find(option => option.AccountType === accountType);

  if (!accountTypeOptions) {
    throw new Error('Account type options not found');
  }

  const { EmployerContributionTaxStatuses } = accountTypeOptions;

  const employerContributionTaxStatusesOptions = EmployerContributionTaxStatuses.map(option => ({
    value: option.Value,
    label: option.Label,
  }));

  const hasContributionStatus =
    accountType &&
    ROTH_ACCOUNT_TYPES.includes(accountType) &&
    accountType !== AccountType.SimpleIra;

  return {
    data: {
      employerContributionTaxStatusesOptions,
      hasContributionStatus,
      employerMatchUnitsOptions,
      employerMatchUnits,
    },
  };
};
